import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@base/ui";
import { ChevronsUpDown, LogOut, UserRound } from "lucide-react";

export type UsuarioDaBarra = {
  readonly nome: string;
  readonly email: string;
  readonly iniciais: string;
  /** Ex.: "Administrador". */
  readonly descricao: string;
};

/** Pessoa logada no rodape da barra lateral, com o menu de sair. */
export function NavUser({
  usuario,
  aoSair,
  aoAbrirPerfil,
  saindo,
}: {
  readonly usuario: UsuarioDaBarra;
  readonly aoSair: () => void;
  readonly saindo: boolean;
  readonly aoAbrirPerfil?: () => void;
}) {
  const { isMobile } = useSidebar();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="size-8 rounded-full">
                <AvatarFallback className="rounded-full bg-ice text-xs font-bold text-secondary">
                  {usuario.iniciais}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{usuario.nome}</span>
                <span className="truncate text-xs opacity-70">{usuario.email}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" aria-hidden="true" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-xl"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="font-normal">
              <div className="grid text-left text-sm leading-tight">
                <span className="truncate font-medium">{usuario.nome}</span>
                <span className="truncate text-xs text-muted-foreground">{usuario.descricao}</span>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            {aoAbrirPerfil ? (
              <DropdownMenuItem onSelect={aoAbrirPerfil}>
                <UserRound aria-hidden="true" />
                Meu perfil
              </DropdownMenuItem>
            ) : null}
            <DropdownMenuItem disabled={saindo} onSelect={aoSair}>
              <LogOut aria-hidden="true" />
              {saindo ? "Saindo…" : "Sair"}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
